import React, {Fragment, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {
  faTruckMedical,
  faTruckFast,
  faHospital,
  faHouseMedical,
  faArrowCircleDown,
  faArrowCircleUp,
  faUserDoctor,
  faPersonMilitaryRifle,
  faPhone,
  faPersonMilitaryPointing,
  faFireExtinguisher, faStickyNote
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-responsive-modal/styles.css';
import { CSSTransition } from 'react-transition-group';
import {GenericContext} from "./App";
import {
  EMERGENCY_SERVICE_TYPE_118,
  EMERGENCY_SERVICE_TYPE_CARABINIERI,
  EMERGENCY_SERVICE_TYPE_CROSS,
  EMERGENCY_SERVICE_TYPE_DOCTOR_ON_CALL,
  EMERGENCY_SERVICE_TYPE_EMERGENCY_MEDICAL_CARE,
  EMERGENCY_SERVICE_TYPE_FIRE_DEPARTMENT,
  EMERGENCY_SERVICE_TYPE_LOCAL_POLICE
} from "../api/wimhome-api";

export default function EmergencyServices({ standalone, type, city, country, region, province }) {
  const { t, /*i18n*/ } = useTranslation();
  const { requestEmergencyServices } =
      React.useContext(GenericContext);

  const [show, setShow] = React.useState(true);
  const [serviceList, setServiceList] = React.useState([]);

  useEffect(() => {
    if(country == null)
      return;
    requestEmergencyServices(type, country, region, province, city).then((data) => {
      setServiceList(data);
    });
  }, [requestEmergencyServices, type, city, country, region, province]);

  function toggleShow() {
    if (!standalone) return;
    setShow((show) => {
      return !show;
    });
  }

  function formatPhoneNumber(number) {
    return number.replace(/[^\w,]/g, '');
  }

  function renderInformation() {
    return (
        <div className='info-emergency-services'>
          {serviceList != null &&
              serviceList.map((service) => {
                let serviceType = <FontAwesomeIcon icon={faTruckFast} />
                switch(service.type) {
                  case EMERGENCY_SERVICE_TYPE_118:
                    serviceType = <FontAwesomeIcon icon={faTruckMedical} />
                    break;

                  case EMERGENCY_SERVICE_TYPE_CROSS:
                    serviceType = <FontAwesomeIcon icon={faHouseMedical} />
                    break;

                  case EMERGENCY_SERVICE_TYPE_DOCTOR_ON_CALL:
                    serviceType = <FontAwesomeIcon icon={faUserDoctor} />
                    break;

                  case EMERGENCY_SERVICE_TYPE_EMERGENCY_MEDICAL_CARE:
                    serviceType = <FontAwesomeIcon icon={faHospital} />
                    break;

                  case EMERGENCY_SERVICE_TYPE_FIRE_DEPARTMENT:
                    serviceType = <FontAwesomeIcon icon={faFireExtinguisher} />
                    break;

                  case EMERGENCY_SERVICE_TYPE_CARABINIERI:
                    serviceType = <FontAwesomeIcon icon={faPersonMilitaryRifle} />
                    break;

                  case EMERGENCY_SERVICE_TYPE_LOCAL_POLICE:
                    serviceType = <FontAwesomeIcon icon={faPersonMilitaryPointing} />
                    break;
                }

                let rowsNumber = 2;
                if(service.note != null) {
                  rowsNumber = rowsNumber + 1;
                }

                return (
                    <div key={service.emergencyServiceId} className={"emergency-service-entry"}>
                      <div style={{gridRowStart: 1, gridRowEnd: -1, gridColumnStart: 1, gridColumnEnd: 2, fontSize: '2em', textAlign: 'center'}}>
                        {serviceType}
                      </div>
                      <div style={{gridRowStart: 1, gridRowEnd: 2, gridColumnStart: 2, gridColumnEnd: 3}}>
                        <strong
                            title={(service.city != null || service.province != null || service.region != null) && (
                              (service.city != null ? `[${service.city}` : '[') +
                              (service.city != null && (service.province != null || service.region != null) ? ' ' : '') +
                              (service.province != null ? `${service.province}` : '') +
                              ((service.city != null || service.province) && (service.region != null) ? ' ' : '') +
                              (service.region != null ? `${service.region}]` : ']')
                            )}
                        >{service.name}</strong>{(service.description != null) && (`, ${service.description}`)}
                      </div>
                      {service.note != null && (
                          <div style={{gridRowStart: 2, gridRowEnd: rowsNumber, gridColumnStart: 2, gridColumnEnd: 3}}>
                            <FontAwesomeIcon icon={faStickyNote} /> <span><em>{service.note}</em></span>
                          </div>
                      )}
                      <div style={{gridRowStart: rowsNumber, gridRowEnd: rowsNumber + 1, gridColumnStart: 2, gridColumnEnd: 3}}>
                          <span>
                            <FontAwesomeIcon icon={faPhone} /> <a className={'phone-link'} href={`tel:${formatPhoneNumber(service.phoneNumber1)}`}>{service.phoneNumber1}</a>
                          </span>
                          {service.phoneNumber2 != null && (
                              <span style={{paddingLeft: '0.5em'}}>
                                <FontAwesomeIcon icon={faPhone} /> <a className={'phone-link'} href={`tel:${formatPhoneNumber(service.phoneNumber2)}`}>{service.phoneNumber2}</a>
                              </span>
                          )}
                          {service.phoneNumber3 != null && (
                              <span>
                                <FontAwesomeIcon icon={faPhone} /> <a className={'phone-link'} href={`tel:${formatPhoneNumber(service.phoneNumber3)}`}>{service.phoneNumber3}</a>
                              </span>
                          )}
                          {service.phoneNumber4 != null && (
                              <span>
                                <FontAwesomeIcon icon={faPhone} /> <a className={'phone-link'} href={`tel:${formatPhoneNumber(service.phoneNumber4)}`}>{service.phoneNumber4}</a>
                              </span>
                          )}
                          {service.phoneNumber5 != null && (
                              <span>
                                <FontAwesomeIcon icon={faPhone} /> <a className={'phone-link'} href={`tel:${formatPhoneNumber(service.phoneNumber5)}`}>{service.phoneNumber5}</a>
                              </span>
                          )}
                      </div>
                    </div>
                );
              })}
        </div>
    );
  }

  return (
      <div className={standalone ? 'info-emergency-services-div' : 'info-emergency-services-div-embedded'}>
        <h1 className={standalone ? 'info-emergency-services-header' : 'info-emergency-services-header-embedded'} onClick={toggleShow}>
          {standalone && (
              <>
            <span className='collapsable-section-desc'>
              <FontAwesomeIcon icon={show ? faArrowCircleUp : faArrowCircleDown}/>
              {`${t('emergencyServices.title')}: ${serviceList !== null ? serviceList.size : '...'}`}
            </span>
              </>
          )}
          {!standalone && <span>{`${t('emergencyServices.title')}`}</span>}
        </h1>
        <hr/>
        {standalone && (
            <CSSTransition classNames='guests-trans' in={show} nodeRef={nodeRef} timeout={250} unmountOnExit>
              <div ref={nodeRef}>
                {renderInformation()}
              </div>
            </CSSTransition>
        )}
        {!standalone && renderInformation()}
      </div>
  );
}
